module.exports = __webpack_public_path__ + "img/search.88b39b88.svg";